import React, { useState } from 'react'; // <--- 'userstate' কে 'useState' করা হয়েছে
import './login.css';
import { Link } from 'react-router-dom';
import { auth } from '../../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom'

const Login = () => { 
  const [email, setEmail] = useState(''); 
  const [password, setPassword] = useState(''); 

  const navigate = useNavigate()

  const submitHandler = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        console.log("লগইন সফল হয়েছে:", user);
        navigate('/dashboard')
      })
      .catch((error) => {
        console.error("লগইন এ সমস্যা:", error.message); // error.message ব্যবহার করা ভালো
      });
  };

  return (
    <div className='login-wrapper'>
      <div className='login-container'>

        <div className='login-boxes login-left'>
          {/* কোনো ছবি বা গ্রাফিক্স এখানে থাকতে পারে */}
        </div>

        <div className='login-boxes login-right'>
          <h2 className='login-heading'>Login</h2>
          <form onSubmit={submitHandler}>
            <input
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              className='login-input'
              type='email'
              placeholder='Email'
              required // ইনপুট ফিল্ড খালি রাখা আটকাতে 'required' যোগ করতে পারেন
            />
            <input
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              className='login-input'
              type='password'
              placeholder='Password'
              required // ইনপুট ফিল্ড খালি রাখা আটকাতে 'required' যোগ করতে পারেন
            />
            <input className='login-input login-btn' type='submit' value="Login" /> {/* বাটনে "Login" লেখা দেখানো হচ্ছে */}
          </form>
          <Link className='register-link' to="/register">Create an Account</Link>
        </div>

      </div>
    </div>
  );
};

export default Login; // <--- কম্পোনেন্টের নামের সাথে মিলিয়ে পরিবর্তন করা হয়েছে